import axios from 'axios';
import { getUserToken } from '../../utils/localStoarege';
import { clinicToken, hardwareApi, oldHardwareApi } from '../../constants/apis/clinic_apis';


export const getDoses = async ({ machineId }) => {
    const token = getUserToken();
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.get(hardwareApi + `?machine_id=${machineId}`, config);
    return response;
};

export const getLastMachineDoses = async ({ machineId }) => {
    const token = getUserToken();
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.get(hardwareApi + `/${machineId}` + "/last_machine_hardware/", config);
    return response;
};

export const addDose = async (data) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${getUserToken()}`,
        },
    };

    const response = await axios.post(`${hardwareApi}/`, data, config);

    return response;
};

export const completeDose = async (machine_hardware_id) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${getUserToken()}`,
        },
    };

    const response = await axios.patch(`${hardwareApi}/${machine_hardware_id}/`, { status: 'Completed', }, config);

    return response;
};

export const deleteDose = async (machine_hardware_id) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${getUserToken()}`,
        },
    };

    const response = await axios.patch(
        `${hardwareApi}/${machine_hardware_id}/`,
        { is_deleted: true },
        config
    );

    return response;
};

// OLD MACHINES //
export const getOldDoses = async ({ machineId }) => {
    const token = clinicToken
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.get(oldHardwareApi + `?machine_id=${machineId}`, config);
    return response;
};

export const getOldLastMachineDoses = async ({ machineId }) => {
    const token = clinicToken
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.get(oldHardwareApi + `/${machineId}` + "/last_machine_hardware/", config);
    return response;
};

export const addOldDose = async (data) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${clinicToken}`,
        },
    };

    const response = await axios.post(`${oldHardwareApi}/`, data, config);

    return response;
};

export const completeOldDose = async (machine_hardware_id) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${clinicToken}`,
        },
    };

    const response = await axios.patch(`${oldHardwareApi}/${machine_hardware_id}/`, { status: 'Completed', }, config);

    return response;
};

export const deleteOldDose = async (machine_hardware_id) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${clinicToken}`,
        },
    };

    const response = await axios.delete(`${oldHardwareApi}/${machine_hardware_id}/`, config);

    return response;
};
